import React, { useState, useEffect } from 'react';
import { formatCountdown } from '../../utils/timeUtils';

export const BrazilClockCountdown = React.memo(function BrazilClockCountdown({ closeTime }: { closeTime: number }) {
  const generateRemainingStr = () => {
    const now = Date.now();
    return formatCountdown(closeTime - now);
  };
  const [remainingStr, setRemainingStr] = useState(generateRemainingStr());

  useEffect(() => {
    setRemainingStr(generateRemainingStr());
    const interval = setInterval(() => {
      setRemainingStr(generateRemainingStr());
    }, 1000);
    return () => clearInterval(interval);
  }, [closeTime]);

  if (!remainingStr) return null;

  const closeDateStr = new Date(closeTime).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'America/Sao_Paulo' });

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-3">
      <span className="text-[9px] md:text-[10px] uppercase tracking-[1px] text-[#00d9ff]/70 font-semibold">Fechamento</span>
      <span className="text-[#00d9ff] font-mono text-sm md:text-lg lg:text-xl font-bold tracking-[1px] drop-shadow-[0_0_5px_rgba(0,217,255,0.4)] leading-none">{remainingStr}</span>
      <span className="text-[#a3aabf] font-mono text-[9px] md:text-[10px] tracking-[1px] sm:ml-1 sm:pl-2 sm:border-l border-[#00d9ff]/30 leading-none opacity-80">{closeDateStr}</span>
    </div>
  );
}, (prevProps, nextProps) => prevProps.closeTime === nextProps.closeTime);

export const BrazilClock = React.memo(function BrazilClock({ closeTime, latencyMs }: { closeTime?: number, latencyMs?: number | null }) {
  if (!closeTime) return null;
  
  return (
    <div className="flex flex-col items-start gap-1 pointer-events-none mt-1.5 md:mt-2 opacity-80">
      <div className="flex items-start sm:items-center gap-2 px-2 py-1.5 md:px-3 md:py-2 rounded border border-[#00d9ff]/30 bg-transparent w-max max-w-full">
        <BrazilClockCountdown closeTime={closeTime} />
      </div>
      {latencyMs !== undefined && latencyMs !== null && (
        <div className="flex items-center gap-1 pl-1 text-[#00ffa3] font-mono text-[9px] md:text-[10px] uppercase tracking-[1px] opacity-80" title="Latência de Dados ao Vivo">
           <span className="w-1.5 h-1.5 rounded-full bg-[#00ffa3] animate-pulse"></span>
           {latencyMs}ms
        </div>
      )}
    </div>
  );
}, (prevProps, nextProps) => prevProps.closeTime === nextProps.closeTime && prevProps.latencyMs === nextProps.latencyMs);

export const CandleCountdown = React.memo(function CandleCountdown({ closeTime }: { closeTime?: number }) {
  const [remainingStr, setRemainingStr] = useState("");

  useEffect(() => {
    if (!closeTime) {
      setRemainingStr("");
      return;
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const diff = closeTime - now;
      setRemainingStr(formatCountdown(diff));
    }, 1000);
    return () => clearInterval(interval);
  }, [closeTime]);

  if (!remainingStr) return null;
  
  return <span className="ml-2 bg-black/60 px-1.5 py-0.5 rounded text-white font-mono text-[11px] tracking-widest">{remainingStr}</span>;
}, (prevProps, nextProps) => prevProps.closeTime === nextProps.closeTime);
